
import { onMounted, ref } from "vue";
import axios from "axios";
import { Shift } from "@/models/shift";

import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import moment from "moment";
import {  useRouter } from 'vue-router';
export default {
  name: "AdminShiftList",
  components: { VPagination },
  methods: {
    dateTime(value: Date) {
      return moment(value).format("DD-MMM-YYYY HH:mm");
    },
    dateOnly(value: Date) {
      return moment(value).format("DD-MMM-YYYY");
    },
  },
  setup() {
    const shifts = ref([]);
    const lastPage = ref(0);
    const search = ref("");
    const router = useRouter();


    const load = async (page = 1) => {
      const { data } = await axios.get(
        `shifts?page=${page}&take=50&search=${search.value}`
      );
      shifts.value = data.data;
      lastPage.value = data.meta.last_page;
    };

    onMounted(load);

    const del = async (id: number) => {
      if (confirm("Are You Sure?")) {
        await axios.delete(`shifts/${id}`);

        shifts.value = shifts.value.filter((u: Shift) => u.id !== id);
      }
    };
    const searchcall = async () => {
      load();
    };
    const releaseall = async () => {
    
      const datarelease = await axios.get(`shifts/created/releaseall`);
      await router.push('/shifts');
    };
    const searchclear = async () => {
      search.value = "";

      load();
    };

    return {
      shifts,
      lastPage,
      search,
      del,
      load,
      searchcall,
      releaseall,
      searchclear,
    };
  },
};
